import type { ENVType } from '@/types/ENV'

const ENV: ENVType = {
  APP_URL: import.meta.env.VITE_APP_URL ?? 'http://localhost:3000/',

  // make sure to end url with a '/'
  API_URL: import.meta.env.VITE_API_URL ?? 'http://localhost:5000/',
  MSAL_TENANT_ID: import.meta.env.VITE_MSAL_TENANT_ID ?? '9c1d6af6-94df-4a4c-9b70-26edaee05a21',
  MSAL_CLIENT_ID: import.meta.env.VITE_MSAL_CLIENT_ID ?? 'b9d130f7-b524-454a-9523-8b95031294e4',
  MSAL_REDIRECT_URI: import.meta.env.VITE_MSAL_REDIRECT_URI ?? '/',
  MSAL_POST_LOGOUT_REDIRECT_URI: import.meta.env.VITE_MSAL_POST_LOGOUT_REDIRECT_URI ?? '/',
  TOKEN_API_URL: import.meta.env.VITE_TOKEN_API_URL ?? 'http://localhost:5000/',
  TOKEN_API_CLIENT_ID: import.meta.env.VITE_RBAC_TOKEN_API_CLIENT_ID ?? '',
  TOKEN_API_CLIENT_SECRET: import.meta.env.VITE_RBAC_TOKEN_API_CLIENT_SECRET ?? '',
  USE_KONG_API: import.meta.env.VITE_USE_KONG_API ? Boolean(import.meta.env.VITE_USE_KONG_API) : false
}

export default ENV
